import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** localStorage から weekStartsOn を取得 (0=日曜, 1=月曜) */
export function getWeekStartsOn(): 0 | 1 {
  return localStorage.getItem('weekStartsOn') === '0' ? 0 : 1;
}

const ALL_DAY_LABELS = ['日', '月', '火', '水', '木', '金', '土'];

/** weekStartsOn に応じた曜日ラベル配列を返す */
export function getDayLabels(weekStartsOn: 0 | 1): string[] {
  if (weekStartsOn === 0) return ALL_DAY_LABELS;
  return [...ALL_DAY_LABELS.slice(1), ALL_DAY_LABELS[0]];
}
